import useSWR from 'swr';

import { ShopItem } from '../types/events/shop';
import { PaginationQuery, PaginationResponse } from '../types/pagination';
import { toQueryParams } from '../utils';
import axios, { endpoints, fetcher } from '../utils/axios';

export async function findShopItems(
  eventId: number,
  params?: PaginationQuery
): Promise<PaginationResponse<ShopItem>> {
  const url = endpoints.shopItems.findAll(eventId);

  const { data } = await axios.get<PaginationResponse<ShopItem>>(`${url}?${toQueryParams(params)}`);
  return data;
}

export function useGetShopItem(eventId: number) {
  const url = endpoints.shopItems.findAll(eventId);
  return useSWR<PaginationResponse<ShopItem>>(url, fetcher, {
    keepPreviousData: false,
    revalidateOnFocus: true,
  });
}
